import axios from 'axios'

const deleteRejectedCode = async (id, packageId) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/removeCodesFromPackage/${packageId}?is_active=0&codes=[${id}]`,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data.data
  } catch (error) {
    throw error
  }
}

export default deleteRejectedCode
